module.exports = __webpack_public_path__ + "media/flags/tw-2a1ca9e0.svg";